import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";


export class ItemCollectMode extends Cloneable {
    static DISABLED= new ItemCollectMode(0, "DISABLED");
    static ENABLED = new ItemCollectMode(1, "ENABLED");
    static CONFIRM = new ItemCollectMode(2, "CONFIRM");
    static TIMEOUT = new ItemCollectMode(3, "TIMEOUT");
    static SELL    = new ItemCollectMode(4, "SELL");

    static _values = [
        this.DISABLED,
        this.ENABLED,
        this.CONFIRM,
        this.TIMEOUT,
        this.SELL
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemCollectMode.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemCollectMode) {
            return ItemCollectMode._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemCollectMode) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemCollectMode());
        } else if (target instanceof ItemCollectMode) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemCollectMode, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});